import { render, staticRenderFns } from "./AddNewOtifTargetPopUp.vue?vue&type=template&id=71ca8a0d&scoped=true&"
import script from "./AddNewOtifTargetPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewOtifTargetPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewOtifTargetPopUp.vue?vue&type=style&index=0&id=71ca8a0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca8a0d",
  null
  
)

export default component.exports